

export default function AboutMeComponent() {

    return (
        <div>
            <main>
                <section className="container container-wide container-single">
                    <section id="" className="ns-bio-hero alignfull">
                        <div className="container ns-bio-hero__info">
                            <div className="ns-bio-hero__info__content">
                                <h1>MEET HERSTORY</h1>
                            </div>
                        </div>
                        <div className="ns-bio-hero__image">
                            <figure>
                                <img
                                    decoding="async"
                                    src="https://firebasestorage.googleapis.com/v0/b/herstory-36c57.firebasestorage.app/o/website%2Fmedia%2Feliza-forest-image.webp?alt=media&token=5f97c9ac-0943-4664-a775-70173a41ea03"
                                    alt="Women professionals networking and connecting at an outdoor event in New York City"
                                />
                            </figure>
                        </div>
                    </section>

                    <div className="flex items-center justify-center">
                        <div className="w-3/4">

                            <h4 className="wp-block-heading">
                                <strong>HerStory started with a phone call that broke Eliza Greenberg’s heart.</strong>
                            </h4>

                            <p>It was 2018. Eliza had spent years working with consumer brands, learning how organic
                                search could be the difference between a business that grows and one that quietly
                                disappears. She had seen it work. She had seen what happened when it didn’t.</p>

                            <p>Around that time, she was showing up to events all over New York City. Startup nights,
                                founder meetups, women in business gatherings. And what she kept finding were
                                extraordinary people. Women who had poured everything into their businesses. Brilliant
                                products, real expertise, years of sacrifice. The kind of founders who deserved to be
                                found.</p>

                            <figure className="wp-block-image size-full">
                                <img
                                    decoding="async"
                                    src="https://firebasestorage.googleapis.com/v0/b/herstory-36c57.firebasestorage.app/o/website%2Fmedia%2Feliza_arms_crossed_img.webp?alt=media&token=9b754828-635e-47d6-ae80-fac225d0bdef"
                                    alt="Confident woman founder with arms crossed in a modern office"
                                />
                            </figure>

                            <p>Then a friend called. She was shutting down. Not because her business wasn’t good. Not
                                because her customers didn’t love her. But because new customers couldn’t find her.
                                They were searching for exactly what she offered, and her name never came up. Someone
                                else got the click. Someone else got the sale. And eventually, the silence became too
                                loud to keep fighting.</p>

                            <p>That call stayed with Eliza. She knew what had happened. The algorithm didn’t care how
                                hard her friend had worked or how good her product was. Search engines favor the brands
                                with the biggest budgets, the most backlinks, the agencies on retainer. Bootstrapped
                                founders, especially women, are starting from the back of a very long line.</p>

                            <p>Women-owned businesses are already navigating rougher water than most. They raise less
                                capital. They get fewer introductions. They carry their businesses on their own backs
                                because that’s what it takes. And then they go online and find that the digital world
                                has its own way of keeping them invisible, ranking the big players first and leaving
                                everyone else to fight over whatever’s left.</p>

                            <p>Eliza had already mastered how to beat that system. She knew that organic search, done
                                right, was the great equalizer. A small brand with the right SEO strategy could outrank
                                a competitor ten times its size. Customers searching for exactly what you offer can
                                find you first. Not because you outspent anyone, but because you showed up smarter.</p>

                            <figure className="wp-block-image size-full">
                                <img
                                    decoding="async"
                                    src="https://firebasestorage.googleapis.com/v0/b/herstory-36c57.firebasestorage.app/o/website%2Fmedia%2Feliza_image.webp?alt=media&token=f153f0a3-bd3c-427b-96fc-bbf5b2bc06df"
                                    alt="Woman founder focused on a walk"
                                />
                            </figure>

                            <p>She founded HerStory SEO to make that possible for every woman building a business
                                from the ground up.</p>

                            <p>The name is intentional. History has always been written by the people with the
                                loudest voice and the biggest platform. HerStory exists to change who gets heard. To
                                give women in business the same visibility, the same reach, the same seat at the top
                                of the search results that larger brands take for granted. Not someday. Now.</p>

                            <p>Since 2018, HerStory has worked with over 240 founders who were done being invisible.
                                Women who had something real to offer and just needed the world to be able to find
                                them. That’s the only work Eliza has ever wanted to do, and it’s the only work
                                HerStory will ever be built around.</p>

                            <h4 className="wp-block-heading">
                                <strong>Your story deserves to be found. We make sure it is.</strong>
                            </h4>

                        </div>
                    </div>

                </section>
            </main>
        </div>
    )
}